export default __webpack_public_path__ + "static/signup-forms-ab7be4e450e670d49cf874cbd70f9616.png";